<tr>
  <td>
    <div class="d-flex align-items-center">
      <div class="symbol symbol-45px me-5">
        <span class="btn btn-icon btn-bg-light btn-sm me-1 cursor-default">
          {{userInvitation.firstName | appInitials:userInvitation.lastName}}
        </span>
      </div>
      <div class="d-flex justify-content-start flex-column">
        <span class="text-dark fw-bolder fs-6 text-truncate mw-200px">
          {{userInvitation.firstName}} {{userInvitation.lastName}}
        </span>
        <span class="text-muted fw-bold d-block fs-7 text-truncate mw-200px">
          {{userInvitation.email}}
        </span>
      </div>
    </div>
  </td>
  <td>
    <span *ngIf="userInvitation.status === invitationStatuses.WAITING" class="badge badge-light-warning fs-7 fw-bold">
      {{'USERS.WAITING_FOR_ACCEPT' | translate}}
    </span>
    <span *ngIf="userInvitation.status === invitationStatuses.CONFIRMED" class="badge badge-light-success fs-7 fw-bold">
      {{'USERS.CONFIRMED' | translate}}
    </span>
    <span *ngIf="userInvitation.status === invitationStatuses.EXPIRED" class="badge badge-light-success fs-7 fw-bold">
      {{'USERS.EXPIRED' | translate}}
    </span>
    <span *ngIf="userInvitation.status === invitationStatuses.ERROR" class="badge badge-light-danger fs-7 fw-bold">
      {{'USERS.ERROR' | translate}}
    </span>
    <span *ngIf="userInvitation.status === invitationStatuses.CANCELLED" class="badge badge-light-danger fs-7 fw-bold">
      {{'USERS.CANCELLED' | translate}}
    </span>
  </td>
  <ng-container *ngIf="whitelabelTemplate">
    <td class="mw-150px pe-3">
      {{ userInvitation.sellers | appList }}
    </td>
    <td class="mw-150px">
      {{ userInvitation.brands | appList }}
    </td>
  </ng-container>
  <td>
    <div *ngIf="userInvitation.status !== invitationStatuses.CONFIRMED" class="d-flex justify-content-end flex-shrink-0">
      <button
        *ngIf="hasReinviteButton; else cancelButton"
        class="btn btn-sm btn-icon btn-light btn-active-light-primary"
        (click)="resend.emit(userInvitation)"
        [disabled]="!canManageInvitations"
        [ngbTooltip]="'COMMON.RETRY' | translate"
      >
        <span
          [inlineSVG]="'./assets/media/icons/duotune/arrows/arr059.svg'"
          class="svg-icon svg-icon-3 svg-icon-primary"
        ></span>
      </button>
      <ng-template #cancelButton>
        <button
          class="btn btn-sm btn-icon btn-light btn-active-light-primary"
          (click)="cancel.emit(userInvitation)"
          [disabled]="!canManageInvitations"
          [ngbTooltip]="'COMMON.CANCEL' | translate"
        >
          <span
            [inlineSVG]="'./assets/media/icons/duotune/arrows/arr011.svg'"
            class="svg-icon svg-icon-3 svg-icon-primary"
          ></span>
        </button>
      </ng-template>
      <button
        class="btn btn-icon btn-bg-light btn-active-light-primary btn-sm ms-3"
        (click)="delete.emit(userInvitation)"
        [disabled]="false"
        [ngbTooltip]="'AD_SLOTS.BUTTON.DELETE' | translate"
      >
        <span
          [inlineSVG]="'./assets/media/icons/duotune/general/gen027.svg'"
          class="svg-icon svg-icon-3 svg-icon-primary"
        ></span>
      </button>
    </div>
  </td>
</tr>
